export default "__VITE_ASSET__f1e7f929__"